import { render, staticRenderFns } from "./member.html?vue&type=template&id=63510cdc&scoped=true&"
import script from "./member.js?vue&type=script&lang=js&"
export * from "./member.js?vue&type=script&lang=js&"
import style0 from "./member.css?vue&type=style&index=0&id=63510cdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63510cdc",
  null
  
)

export default component.exports